import React from 'react';
import { Form } from '../../../ui/universe';
import { InputNumber, Tooltip } from 'tdesign-react';

/**
 * InputNumber 参数渲染器
 */
function InputNumberRenderer({ params, disabled, inputPageNumber, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <div className="flex">
        <InputNumber
          value={inputPageNumber}
          step={1}
          disabled={disabled}
          min={params.min}
          max={params.max}
          onChange={(value) => {
            if (value === undefined) {
              onChange && onChange(params.min);
            } else if (value > params.max) {
              onChange && onChange(params.max);
            } else if (value < params.min) {
              onChange && onChange(params.min);
            } else {
              onChange && onChange(value);
            }
          }}
        />
      </div>
    </Form.Item>
  );
}

export default InputNumberRenderer;
